import { render } from "./BarraLateral.vue?vue&type=template&id=4aa5bc03&scoped=true&ts=true"
import script from "./BarraLateral.vue?vue&type=script&lang=ts"
export * from "./BarraLateral.vue?vue&type=script&lang=ts"

import "./BarraLateral.vue?vue&type=style&index=0&id=4aa5bc03&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa5bc03"]])

export default __exports__